module.exports = __webpack_public_path__ + "static/media/web_en.c26c5dd0.png";